const guidedFlowFeatures = {
    customFlowSystemId: undefined,
    isDeviceActivationGuideIntentAutoOpenEnabled: false,
    isGuidedFlowRecommendationEnabled: false,
};

const workspaceCustomerFeatures = {
    isAutoSummaryEnabled: false,
    isPreviousSessionSummaryEnabled: false,
};

const workspaceSalesFeatures = {
    isRapportEnabled: false,
    isChecklistSummaryEnabled: false,
    isChallengeEnabled: false,
    isEnrollmentCelebrationEnabled: false,
    isEngagementEnabled: false,
    isGaiaCallResolutionEnabled: false,
    isPersonalizeCoverageEnabled: false,
};

const workspaceExpertFeatures = {
    isProactiveEnabled: false,
    isVerizonCareEnabled: false,
    isSolveLeaderboardEnabled: false,
    isOutageAlertInfoEnabled: false,
    isLightModeEnabled: false,
    isGaiaMultiStepSummaryEnabled: false,
    isExpertPerformanceDashboardEnabled: false,
    isChatIssueSummaryEnabled: false,
    isMicroLearningV2Enabled: false,
    logoutPendingDuration: 3000,
    isTrainingFeedbackEnabled: false,
    isUpdatedEndSessionFlowEnabled: false,
    ignoreEvl: false,
};

/**
 * Maps clean feature flag names (used in code) to actual flag names (used in API)
 * This allows us to use clean names like `isEnrollmentCelebrationEnabled` in code
 * while fetching the actual flag name like `Sales-isEnrollmentCelebrationEnabled`
 */
export const FLAG_NAME_MAP: Record<string, string> = {
    isChallengeEnabled: "Sales-isChallengeEnabled",
    isEnrollmentCelebrationEnabled: "Sales-isEnrollmentCelebrationEnabled",
    isEngagementEnabled: "Sales-isEngagementEnabled",
    isPersonalizeCoverageEnabled: "Sales-isPersonalizeCoverageEnabled",
    isMicroLearningV2Enabled: "EWP-isMicroLearningV2Enabled",
    logoutPendingDuration: "EWP-logoutPendingDuration",
    ignoreEvl: "EWP-ignoreEvl",
    isChecklistSummaryEnabled: "Sales-IsChecklistSummaryEnabled",
    isRapportEnabled: "Sales-isRapportEnabled",
};

export const workspaceFeatures = {
    ...guidedFlowFeatures,
    ...workspaceCustomerFeatures,
    ...workspaceExpertFeatures,
    ...workspaceSalesFeatures,
};
